import { hasEmptySurveyPlaceholder } from '@/utils/editor/sanitize-template-variables';
import { useShowToast } from './useShowToast';

export const useRejection = () => {
  const toast = useShowToast();
  const validateRejectionEmailPayload = (sendRejectEmail, values: any) => {
    let rejectEmailConfig = values?.rejectEmailConfig || {};
    const subject = rejectEmailConfig?.subject || values?.subject;

    if (sendRejectEmail) {
      const from = rejectEmailConfig?.from || values?.from;
      const body = rejectEmailConfig?.body || values?.body;

      if (!from) {
        toast({ title: 'From is mandatory', status: 'error' });
        return false;
      }
      if (!subject) {
        toast({ title: 'Subject is mandatory', status: 'error' });
        return false;
      }
      if (!body) {
        toast({ title: 'Body is mandatory', status: 'error' });
        return false;
      }

      // if survey placeholder is available but no survey is selected
      if (hasEmptySurveyPlaceholder(body)) {
        toast({ title: 'Please select a survey', status: 'error' });
        return false;
      }
    }
    return true;
  };

  return {
    validateRejectionEmailPayload,
  };
};
